import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Col, message, Row, Select, Space } from 'antd';
import { api, endpoints } from '../../../../api';
import { AppearBlock, CloseButton, CustomSelect, DownloadCol, FormItem } from '../../../../styles/styled';
import { UploadComponent } from '../../../NewApplicationPage/components/BookRegistrationComponent/components/BookForm/UploadComponent';
import { FileEditorData } from '../../../NewApplicationPage/components/BookRegistrationComponent/components/BookForm/UploadComponent/UploadComponent';
import { CreateFileRequestType, FileDataType } from '../../../NewApplicationPage/types';
import { ScienceBranchesType, SpecialtiesType } from '../AcademicDegreeForm/types';
import { ExpertScientificTitleType } from './types';

type AcademicTitleProps = {
  removeForm: (id: number) => void;
  updateForm: (id: number, institutionForm: ExpertScientificTitleType) => void;
  id: number;
  formData?: ExpertScientificTitleType;
  scienceBranches: ScienceBranchesType;
  specialties: SpecialtiesType;
};

const { Option } = Select;

export const AcademicTitle: FC<AcademicTitleProps> = ({
  updateForm,
  formData,
  scienceBranches,
  specialties,
  removeForm,
  id,
}) => {
  const [inputsState, setInputsState] = useState<ExpertScientificTitleType>(formData || {});
  const [academicFileState, setAcademicFile] = useState<CreateFileRequestType | null>();
  const firstLoad = useRef(true);

  useEffect(() => {
    if (!firstLoad.current) updateForm(id, inputsState);

    firstLoad.current = false;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsState]);

  const uploadFiles = useCallback(async (fileData: FileDataType) => {
    try {
      const response = await api
        .post<{ success: boolean; file_id: number }>(endpoints.addFile(), {
          ...fileData,
          ext: fileData.title.split('.').pop(),
        })
        .then((el) => {
          return el;
        });

      if (response) {
        setInputsState((prevState) => {
          return { ...prevState, file: { id: response.data.file_id } };
        });

        setAcademicFile({ title: fileData.title, base64: fileData.base64, ext: fileData.ext });
      }
    } catch (err) {
      message.error('Произошла ошибка загрузки файла');
    }
  }, []);

  const beforeUploadFile = async (data: FileEditorData) => {
    await uploadFiles({
      base64: data.data.split('base64,')[1],
      title: data.name as string,
      ext: data.type as string,
    });
  };

  return (
    <AppearBlock padding="40px 20px">
      <CloseButton positioned onClick={() => removeForm(id)}>
        +
      </CloseButton>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <FormItem direction="row">
            <p>Научное звание по специальности</p>
            <CustomSelect
              onChange={(value, option) => {
                setInputsState({
                  ...inputsState,
                  scientific_title: value ? { id: parseInt(Object.values(option)[0]) } : undefined,
                });
              }}
              value={scienceBranches.find((el) => el.id === inputsState?.scientific_title?.id)?.title || ''}
              showSearch
              allowClear
            >
              {scienceBranches.map((el) => {
                return (
                  <Option key={el.id} value={el.title}>
                    {el.title}
                  </Option>
                );
              })}
            </CustomSelect>
          </FormItem>
        </Col>
        <Col span={24}>
          <FormItem direction="row">
            <p>Специальность</p>
            <CustomSelect
              onChange={(value, option) => {
                setInputsState({
                  ...inputsState,
                  specialty: value ? { id: parseInt(Object.values(option)[0]) } : undefined,
                });
              }}
              value={specialties.find((el) => el.id === inputsState?.specialty?.id)?.title || ''}
              showSearch
              allowClear
            >
              {specialties.map((el) => {
                return (
                  <Option key={el.id} value={el.title}>
                    {el.title}
                  </Option>
                );
              })}
            </CustomSelect>
          </FormItem>
        </Col>
        <Col span={24}>
          {' '}
          <DownloadCol span={24} style={{ paddingLeft: '35px' }}>
            <Space align="center">
              <UploadComponent
                onClear={() => setAcademicFile(null)}
                value={
                  academicFileState && inputsState.file
                    ? { title: academicFileState.title, id: inputsState?.file?.id }
                    : undefined
                }
                formats={['.pdf']}
                onChange={beforeUploadFile}
              />
            </Space>
            <p>рекомендуется прикреплять файл в формате .pdf</p>
          </DownloadCol>
        </Col>
      </Row>
    </AppearBlock>
  );
};
